/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportRowErrorDto } from './ImportRowErrorDto';
import {
    ImportRowErrorDtoFromJSON,
    ImportRowErrorDtoFromJSONTyped,
    ImportRowErrorDtoToJSON,
    ImportRowErrorDtoToJSONTyped,
} from './ImportRowErrorDto';

/**
 * 
 * @export
 * @interface ImportRowErrorDtoPagedResponseDto
 */
export interface ImportRowErrorDtoPagedResponseDto {
    /**
     * 
     * @type {Array<ImportRowErrorDto>}
     * @memberof ImportRowErrorDtoPagedResponseDto
     */
    items?: Array<ImportRowErrorDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ImportRowErrorDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportRowErrorDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportRowErrorDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the ImportRowErrorDtoPagedResponseDto interface.
 */
export function instanceOfImportRowErrorDtoPagedResponseDto(value: object): value is ImportRowErrorDtoPagedResponseDto {
    return true;
}

export function ImportRowErrorDtoPagedResponseDtoFromJSON(json: any): ImportRowErrorDtoPagedResponseDto {
    return ImportRowErrorDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function ImportRowErrorDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportRowErrorDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ImportRowErrorDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function ImportRowErrorDtoPagedResponseDtoToJSON(json: any): ImportRowErrorDtoPagedResponseDto {
    return ImportRowErrorDtoPagedResponseDtoToJSONTyped(json, false);
}

export function ImportRowErrorDtoPagedResponseDtoToJSONTyped(value?: ImportRowErrorDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ImportRowErrorDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

